import { Head, router } from "@inertiajs/react"
import { Pencil, Trash2, VenetianMask } from "lucide-react"

import { DataTable } from "@/components/ui/data-table"
import { columns } from "@/components/users/columns"
import AdminLayout from "@/layouts/admin-layout"
import {
  adminUserPath,
  adminUsersPath,
  editAdminUserPath,
  impersonateAdminUserPath,
} from "@/routes"
import type { BreadcrumbItem, Pagy, User } from "@/types"

interface UsersProps {
  users: User[]
  pagy: Pagy
  sort: string | null
  q: {
    name_cont?: string
    state_in?: string[]
  }
}

const breadcrumbs: BreadcrumbItem[] = [
  {
    title: "Users",
    href: adminUsersPath(),
  },
]

export default function Users({ users, pagy, sort }: UsersProps) {
  const handleDelete = (user: User) => {
    router.delete(adminUserPath({ id: user.uid }), {
      preserveState: true,
      preserveScroll: true,
    })
  }

  return (
    <AdminLayout breadcrumbs={breadcrumbs}>
      <Head title={breadcrumbs[breadcrumbs.length - 1].title} />
      <DataTable
        columns={columns}
        data={users}
        pagy={pagy}
        sort={sort}
        onSortChange={(newSort) => {
          router.visit(adminUsersPath(), {
            data: { sort: newSort },
            preserveState: true,
            preserveScroll: true,
          })
        }}
        onPageChange={(page) => {
          router.visit(adminUsersPath(), {
            data: { page: page, sort: sort ?? undefined },
            preserveState: true,
            preserveScroll: true,
          })
        }}
        emptyComponent={
          <div className="text-muted-foreground py-10 text-center">
            No users found.
          </div>
        }
        actions={[
          {
            label: "Edit",
            icon: <Pencil className="h-4 w-4" />,
            onClick: (user: User) =>
              router.visit(editAdminUserPath({ id: user.uid })),
          },
          {
            label: "Impersonate",
            icon: <VenetianMask className="h-4 w-4" />,
            onClick: (user: User) =>
              router.post(impersonateAdminUserPath({ id: user.uid })),
          },
          {
            label: "Delete",
            icon: <Trash2 className="h-4 w-4" />,
            onClick: handleDelete,
            variant: "destructive",
          },
        ]}
      />
    </AdminLayout>
  )
}
